export const icons = [
	'accept',
	'account',
	'account-bg',
	'add',
	'add-bg',
	'age-restriction',
	'arrow-right',
	'arrow-right-short',
	'bag',
	'block',
	'calendar',
	'call',
	'camera',
	'cart',
	'chance',
	'chat',
	'check-bg',
	'checkmark',
	'chevron-down',
	'chevron-left',
	'chevron-right',
	'chevron-up',
	'clear',
	'close',
	'close-bg',
	'coupon',
	'creditcard',
	'customer-support',
	'delete',
	'downvote',
	'draw-date',
	'edit',
	'erase',
	'error',
	'facebook-logo',
	'gift',
	'hint',
	'home',
	'home-stroke',
	'ideal',
	'idin',
	'inbox',
	'info',
	'instagram-logo',
	'kl-shopping-cart',
	'kl-shopping-cart-add',
	'linkedin-logo',
	'location',
	'lock',
	'logout',
	'lotto-xl',
	'manual-input',
	'menu',
	'messenger-logo',
	'more-info-question-mark',
	'no-ticket',
	'notification',
	'pay',
	'payout',
	'pin',
	'play',
	'points',
	'prize',
	'progress-activity',
	'qr-code',
	'reject',
	'reload',
	'reward',
	'scan',
	'scratch-explainer',
	'search',
	'settings',
	'shake',
	'shuffle',
	'stake',
	'stl-club',
	'stl-groupplay',
	'stl-xl',
	'store',
	'subscription-tickets',
	'swap',
	'ticket',
	'ticket-checked',
	'tickets',
	'tiktok-logo',
	'tooltip',
	'tooltip-i',
	'touch-id',
	'upvote',
	'verified',
	'visibility-off',
	'visibility-on',
	'wallet',
	'warning',
	'x-logo',
	'youtube-logo',
] as const;

export const iconAriaLabels: Record<(typeof icons)[number], string> = {
	accept: 'Accepteren',
	account: 'Account',
	'account-bg': 'Account',
	add: 'Toevoegen',
	'add-bg': 'Toevoegen',
	'age-restriction': 'Leeftijdsbeperking',
	'arrow-right': 'Pijl naar rechts',
	'arrow-right-short': 'Pijl naar rechts',
	bag: 'Winkelmandje',
	block: 'Afwijzen',
	calendar: 'Kalender',
	call: 'Telefoon',
	camera: 'Camera',
	cart: 'Winkelwagen',
	chance: 'Kans',
	chat: 'Chat',
	checkmark: 'Vinkje',
	'check-bg': 'Vinkje',
	'chevron-down': 'Pijl naar beneden',
	'chevron-left': 'Pijl naar links',
	'chevron-right': 'Pijl naar rechts',
	'chevron-up': 'Pijl naar boven',
	clear: 'Wissen',
	close: 'Sluiten',
	'close-bg': 'Sluiten',
	coupon: 'Coupon',
	creditcard: 'Creditcard',
	'customer-support': 'Klantenservice',
	delete: 'Verwijderen',
	downvote: 'Omlaag stemmen',
	'draw-date': 'Trekkingsdatum',
	edit: 'Bewerken',
	erase: 'Wissen',
	error: 'Fout',
	'facebook-logo': 'Facebook logo',
	gift: 'Cadeau',
	hint: 'Hint',
	home: 'Huis',
	'home-stroke': 'Huis',
	ideal: 'iDEAL',
	idin: 'iDIN',
	inbox: 'Inbox',
	info: 'Informatie',
	'instagram-logo': 'Instagram logo',
	'kl-shopping-cart': 'Winkelwagen',
	'kl-shopping-cart-add': 'Toevoegen aan winkelwagen',
	'linkedin-logo': 'LinkedIn logo',
	location: 'Locatie',
	lock: 'Slot',
	logout: 'Uitloggen',
	'lotto-xl': 'Lotto XL',
	'manual-input': 'Handmatige invoer',
	menu: 'Menu',
	'messenger-logo': 'Messenger logo',
	'more-info-question-mark': 'Meer informatie',
	'no-ticket': 'Geen ticket',
	notification: 'Melding',
	pay: 'Betalen',
	payout: 'Uitbetaling',
	pin: 'Pin',
	play: 'Afspelen',
	points: 'Punten',
	'progress-activity': 'Bezig met laden',
	prize: 'Prijs',
	'qr-code': 'QR-code',
	reject: 'Afwijzen',
	reload: 'Herladen',
	reward: 'Beloning',
	scan: 'Scannen',
	'scratch-explainer': 'Kras uitleg',
	search: 'Zoeken',
	settings: 'Instellingen',
	shake: 'Schudden',
	shuffle: 'Willekeurig afspelen',
	stake: 'Inzetten',
	'stl-club': 'Staatsloterij Club',
	'stl-groupplay': 'Staatsloterij Groepsspel',
	'stl-xl': 'Staatsloterij XL Lot',
	store: 'Winkel',
	'subscription-tickets': 'Abonnementstickets',
	swap: 'Wisselen',
	ticket: 'Ticket',
	'ticket-checked': 'Ticket gecontroleerd',
	tickets: 'Tickets',
	'tiktok-logo': 'TikTok logo',
	tooltip: 'Tooltip',
	'tooltip-i': 'Tooltip',
	'touch-id': 'Touch ID',
	upvote: 'Omhoog stemmen',
	verified: 'Geverifieerd',
	'visibility-off': 'Zichtbaarheid uit',
	'visibility-on': 'Zichtbaarheid aan',
	wallet: 'Portemonnee',
	warning: 'Waarschuwing',
	'x-logo': 'X logo',
	'youtube-logo': 'YouTube logo',
};

export default icons;
